import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-moments',
  templateUrl: './layout-moments.component.html',
  styleUrls: ['./layout-moments.component.sass']
})
export class LayoutMomentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
